import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'brand_reviews-link_scroll_to_reviews_display-click';

/**
 * Event that is tracked when the user clicks on the reviews rating link shown near the brand name at the top in both PDP and Brand Page. The link will scroll the user down to the reviews display section
 */
export function trackBrandReviewsLinkScrollToReviewsDisplayClick(
  view: string,
  viewport2: string,
  retailerToken: string,
  productToken: string,
  brandToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { view, viewport2, retailerToken, productToken, brandToken },
  });
}
